export const ontimeModal = {
  header: {
    fontWeight: 400,
    letterSpacing: '0.3px',
    padding: '1rem 1.5rem',
    fontSize: '1.25rem',
    color: '#fefefe', // $gray-50
  },
  dialog: {
    borderRadius: '3px',
    padding: 0,
    minHeight: 'min(200px, 10vh)',
    backgroundColor: '#202020', // $gray-1250
    color: '#fefefe', // $gray-50
  },
  body: {
    padding: '1rem',
    fontSize: 'calc(1rem - 2px)',
    display: 'flex',
    flexDirection: 'column',
    gap: '1rem',
  },
  closeButton: {
    color: '#fefefe', // $gray-50
  },
  footer: {
    padding: '0.5rem',
  },
};
